export default "__VITE_ASSET__VXusWJAfCROSknpJEBOXQw__";